var map = {
	"./ai_chat_project/description.json": 1865,
	"./animated_image_generator/description.json": 3785,
	"./calendar_gpt_project/description.json": 9454,
	"./donut_modeling_project/description.json": 9128,
	"./goose_glance_extension/description.json": 5774,
	"./llm_web_app_deployment_project/description.json": 3014,
	"./photography/description.json": 4441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6887;